import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
import { IoMdClose,IoMdRemove,IoMdAdd } from 'react-icons/io';
// import cart context
import { CartContext } from '../contexts/CartContext';
const CartItem = ({item}) => {

  const {removeFromCart,increaseAmount,decreaseAmount}=useContext(CartContext)
// destructure props
  const {id,title,image,price,amount} = item;
  return <div className='flex items-center'>
    <div className='w-full min-h-[120px] flex items-center gap-x-4 border-b'>
      {/* image */}
      <div>
        <img src={image} alt=""
        className='max-w-[50px]'
        />
      </div>
      {/* title and remove icon */}
      <div className='w-full '>
         <span className='text-sm w-4/5'>{title}</span>
         <div className='w-4/5  h-[36px] flex items-center gap-x-5 text-sm'>
         {/* amount */}
         <div className='flex justify-between w-2/5 '>
           {/* decrease */}
         <div className='flex items-center hover:text-red-500 cursor-pointer'
         onClick={()=>decreaseAmount(id)}
         >
         <IoMdRemove />
         </div>
         {/* actual amount */}
         <div>
         {amount}
         </div>
         {/* increase*/}
         <div className='flex items-center hover:text-red-500 cursor-pointer'
         onClick={()=>increaseAmount(id)}
         >
         <IoMdAdd />
         </div>
         </div>

         {/* item price and final price */}
         <div className='w-3/5 flex justify-between'>
          <div>
            ${price}
          </div>
          {/* final price */}
          <div>
           ${`${parseFloat(item.price * amount).toFixed(2)}`}
          </div>
         </div>
        
         </div>
      </div>
     
      
    </div>
    {/* remove button */}
      <div className='text-xl cursor-pointer'
      onClick={()=> removeFromCart(id)}
      >
        <IoMdClose className='text-gray-500 hover:text-red-500'/>
      </div>
  </div>;
};

export default CartItem;
